var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"padding-top"},[_c('AppList',{attrs:{"opts":_vm.opts,"items":_vm.$store.state.alerts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }